import { Button } from "@mui/material";
import Icon from "components/icon/icon";
import Results from "components/results/results";
import { RightPanel } from "helpers/constants";
import { AppAction, AppContext } from "helpers/context";
import { getCheckedCounts } from "helpers/helpers";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import styles from "./events-location.module.scss";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);

function EventsLocation() {
  const [context, dispatch] = useContext(AppContext);
  const [t] = useTranslation();

  const openModal = (): void => {
    dispatch({ type: AppAction.setMultipleAnalyseModal, payload: { type: "2" } });
  };

  const goBlack = () => {
    dispatch({ type: AppAction.setSingleLocationAnalysed, payload: false });
    dispatch({
      type: AppAction.setCurrentEventsLocationInfo,
      payload: undefined,
    });
    if (context.currentMultipleLocationInfo || context.searchLocationInfo) {
      dispatch({ type: AppAction.setRightPanel, payload: RightPanel.Single });
    } else if (context.currentMultipleLocations) {
      dispatch({ type: AppAction.setRightPanel, payload: RightPanel.Multiple });
    } else {
      dispatch({ type: AppAction.setRightPanel, payload: RightPanel.Empty });
    }
  };

  const closeLocation = (): void => {
    goBlack();
  };

  return context.currentEventsLocationInfo && (
    <div className={styles.single}>
      <div className="overflow-auto flex-1">
        <div className={styles.title}>
          <div className="flex items-center overflow-hidden">
            {(context.currentMultipleLocations || context.currentMultipleLocationInfo || context.searchLocationInfo) && (
              <Icon
                icon="arrow_back"
                style={{
                  flexShrink: 0,
                  width: "36px",
                  height: "36px",
                  padding: "6px",
                }}
                onClick={goBlack}
              />
            )}
            <div className="truncate">
              {context.currentEventsLocationInfo.name}
            </div>
          </div>
          <div className="flex items-center">
            <div>
              <Icon onClick={closeLocation} />
            </div>
          </div>
        </div>
        <div className={styles.info}>
          <div className={styles.image}>
            <img src={`/events/${context.currentEventsLocationInfo.type === "Cyclone" || context.currentEventsLocationInfo.type === "Winterstorm" ? "Storm" : context.currentEventsLocationInfo.type}-hover.png`} ></img>
          </div>
          <div className={styles.address}>
            <div className={styles.addressTitle}>
              {context.currentEventsLocationInfo.name}
            </div>
            <div className={styles.addressContent}>
              <div>
                <span>{t("events.peril")}</span>
                <span>{t("events." + context.currentEventsLocationInfo.type)}</span>
              </div>
              <div>
                <span>{t("events.date")}</span>
                <span>{context.currentEventsLocationInfo.type === "Earthquake" ? `${dayjs(context.currentEventsLocationInfo.eventDateTime).utc().format('YYYY-MM-DD HH:mm:ss')} UTC` : dayjs(context.currentEventsLocationInfo.eventDateTime).tz('Asia/Shanghai').format('YYYY-MM-DD')}</span>
              </div>
              <div>
                <span>{t("events.lastUpdate")}</span>
                <span>{context.currentEventsLocationInfo.type === "Earthquake" ? `${dayjs(context.currentEventsLocationInfo.updateDateTime).utc().format('YYYY-MM-DD HH:mm:ss')} UTC` : dayjs(context.currentEventsLocationInfo.updateDateTime).tz('Asia/Shanghai').format('YYYY-MM-DD')}</span>
              </div>
              <div>
                <span>{t("events.location")}</span>
                <span>{`${context.currentEventsLocationInfo.longitude}, ${context.currentEventsLocationInfo.latitude}`}</span>
              </div>
              <div>
                <span>{t("events.description")}</span>
                <i>{context.currentEventsLocationInfo.description}</i>
              </div>
              <div>
                <span>{t("events.source")}</span>
                <span>{context.currentEventsLocationInfo.source}</span>
              </div>
            </div>
          </div>
        </div>
        <Results />
      </div>
      <div className={styles.buttons}>
        {context.menu && context.menu.find((item) => item.id === "102") && (
          <Button
            color="success"
            variant="contained"
            className="w-full"
            disabled={
              getCheckedCounts(context.currentMultipleLocations?.items) ===
              "0"
            }
            onClick={openModal}
          >
            {t("buttons.analyseEvents")}
          </Button>
        )}
      </div>
    </div>
  );
}

export default EventsLocation;


